export interface MeasurePoint { x: number; y: number; z: number }

// What the Scene engine reports with measureResult / areaResult about the
// orthomosaic a measurement can be stored on: points in that ortho's map CRS
// (z = map units above the image), length / area in metres (groundFrame).
// onLayer: every clicked point hit this ortho; otherwise it is only the first
// visible one.
export interface OrthoMeasureRef { fileId: string; onLayer: boolean }
export interface OrthoLineResult extends OrthoMeasureRef { start: MeasurePoint; end: MeasurePoint; distance: number }
export interface OrthoAreaResult extends OrthoMeasureRef { points: MeasurePoint[]; area: number }

export type MeasureTarget = { kind: 'ortho'; fileId: string } | { kind: 'cloud' } | { kind: 'none' };

// A measurement drawn entirely on an ortho belongs to it, and so does one with
// no visible cloud to hold it; anything else stays on the cloud, in world space.
export const measurementTarget = (
  { ortho, cloudVisible }: { ortho?: OrthoMeasureRef | null; cloudVisible: boolean },
): MeasureTarget => {
  if (ortho?.fileId && (ortho.onLayer || !cloudVisible)) return { kind: 'ortho', fileId: ortho.fileId };
  return cloudVisible ? { kind: 'cloud' } : { kind: 'none' };
};

export const measurementLabel = (m: { kind: string; distance?: number | null; area?: number | null }) =>
  m.kind === 'area' ? `Area · ${(m.area ?? 0).toFixed(2)} m²` : `Distance · ${(m.distance ?? 0).toFixed(2)} m`;
